import React from 'react';

import TableCell from './TableCell';
import Flex from '../Layout/Flex';

const TableActions = ({ children, ...rest }) => (
  <TableCell {...rest}>
    <Flex center middle right xSpace>
      {children}
    </Flex>
  </TableCell>
);

export default TableActions;
